import React from 'react';
import { VideoJsPlayerOptions } from 'video.js';

import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';

import VideoJS from '../utils/VideoJS';

interface IVideoPreviewProps {
  title: string;
  show: boolean;
  fileSource?: string;
  onClose: Function;
}

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 50,
  },
  frameContainer: {
    width: 1024,
    border: 'none',
  },
});

export default function (props: IVideoPreviewProps) {
  const classes = useStyles();

  const videoJsOptions: VideoJsPlayerOptions = {
    autoplay: true,
    controls: true,
    responsive: true,
    fluid: true,
    sources: [
      {
        type: 'application/x-mpegUrl',
        src: props.fileSource || '',
      },
    ],
  };

  return (
    <Dialog
      onClose={() => props.onClose()}
      open={props.show}
      sx={{ '& .MuiPaper-root': { maxWidth: '1024px' } }}
    >
      <Box sx={{ padding: '8px 8px 8px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontSize: '1.2rem', fontWeight: 600 }}>{props.title}</span>
        <IconButton onClick={() => props.onClose()}>
          <CloseIcon />
        </IconButton>
      </Box>
      {props.fileSource ? (
        <div className={classes.frameContainer}>
          <VideoJS options={videoJsOptions} />
        </div>
      ) : (
        <CircularProgress />
      )}
    </Dialog>
  );
}
